// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._3sXmF {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: background 0.2s ease;
  min-height: 28px;
}

._3sXmF:hover {
  cursor: pointer;
  background: rgba(220, 220, 220, 0.4);
}

._ygkSb {
  overflow-y: auto;
  transition: background 0.2s ease;
}

/* Width */
._ygkSb::-webkit-scrollbar {
  width: 8px;
}
/* Track */
._ygkSb::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
._ygkSb::-webkit-scrollbar-thumb {
  background: #ccc;
}
/* Handle on hover */
._ygkSb::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}
/* Handle on drag */
._ygkSb::-webkit-scrollbar-thumb:active {
  background: #666;
}

._ygkSb:hover {
  cursor: pointer;
  background: rgba(220, 220, 220, 0.4);
}

._1EEDX {
  width: 100%;
  padding: 5px;
  display: block;
  margin: 3px 0;
  scrollbar-width: thin;
}

/* Width */
._1EEDX::-webkit-scrollbar {
  width: 8px;
}
/* Track */
._1EEDX::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
._1EEDX::-webkit-scrollbar-thumb {
  background: #ccc;
}
/* Handle on hover */
._1EEDX::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}
/* Handle on drag */
._1EEDX::-webkit-scrollbar-thumb:active {
  background: #666;
}

._3qwMT {
  color: #999;
}

._3F-ST {
  display: inline !important;
}

._38077 {
  cursor: auto !important;
}

._38077:hover {
  cursor: auto !important;
}

._2_49w {
  display: flex;
}

._PG2W0 {
  background-color: #fff;
  color: black;
  border: 0;
  outline: none;
  min-width: 28px;
}

._PG2W0:focus {
  border: 0;
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-edit-text/dist/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;AACA,UAAU;AACV;EACE,mBAAmB;AACrB;AACA,WAAW;AACX;EACE,gBAAgB;AAClB;AACA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;AACA,UAAU;AACV;EACE,mBAAmB;AACrB;AACA,WAAW;AACX;EACE,gBAAgB;AAClB;AACA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;AACf","sourcesContent":["._3sXmF {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: background 0.2s ease;\n  min-height: 28px;\n}\n\n._3sXmF:hover {\n  cursor: pointer;\n  background: rgba(220, 220, 220, 0.4);\n}\n\n._ygkSb {\n  overflow-y: auto;\n  transition: background 0.2s ease;\n}\n\n/* Width */\n._ygkSb::-webkit-scrollbar {\n  width: 8px;\n}\n/* Track */\n._ygkSb::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n/* Handle */\n._ygkSb::-webkit-scrollbar-thumb {\n  background: #ccc;\n}\n/* Handle on hover */\n._ygkSb::-webkit-scrollbar-thumb:hover {\n  background: #aaa;\n}\n/* Handle on drag */\n._ygkSb::-webkit-scrollbar-thumb:active {\n  background: #666;\n}\n\n._ygkSb:hover {\n  cursor: pointer;\n  background: rgba(220, 220, 220, 0.4);\n}\n\n._1EEDX {\n  width: 100%;\n  padding: 5px;\n  display: block;\n  margin: 3px 0;\n  scrollbar-width: thin;\n}\n\n/* Width */\n._1EEDX::-webkit-scrollbar {\n  width: 8px;\n}\n/* Track */\n._1EEDX::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n/* Handle */\n._1EEDX::-webkit-scrollbar-thumb {\n  background: #ccc;\n}\n/* Handle on hover */\n._1EEDX::-webkit-scrollbar-thumb:hover {\n  background: #aaa;\n}\n/* Handle on drag */\n._1EEDX::-webkit-scrollbar-thumb:active {\n  background: #666;\n}\n\n._3qwMT {\n  color: #999;\n}\n\n._3F-ST {\n  display: inline !important;\n}\n\n._38077 {\n  cursor: auto !important;\n}\n\n._38077:hover {\n  cursor: auto !important;\n}\n\n._2_49w {\n  display: flex;\n}\n\n._PG2W0 {\n  background-color: #fff;\n  color: black;\n  border: 0;\n  outline: none;\n  min-width: 28px;\n}\n\n._PG2W0:focus {\n  border: 0;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
